import { Outlet } from "react-router-dom";
import { Settings as SettingsIcon } from "lucide-react";
import SettingsSidebar from "./SettingsSidebar";
import { PageHeader } from "../../components/em/ui";
import "./em-settings.css";

const Settings = () => {
  const role = localStorage.getItem("role");

  return (
    <div className="em-settings">
      <PageHeader
        icon={SettingsIcon}
        title="Settings"
        subtitle="Manage your workspace preferences and configuration"
      />

      <div className="em-settings-grid">
        <SettingsSidebar role={role} />
        <main className="em-settings-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Settings;
